angular.module('angus.controllers').directive('monitors', function() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'templates/tankMonitor/inventoryManagement/monitors/monitorsView.html'
    };
});
  